import React from 'react'

import Box from '@mui/material/Box';

const StyledTab: React.FC<{
  isSelected: boolean;
  onClick: () => void;
}> = (props) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      color={props.isSelected ? '#F0F0F0' : 'black'}
      bgcolor={props.isSelected ? '#161728' : '#F0F0F0'}
      padding="3px 10px"
      height="36px"
      width="77px"
      borderRadius="10px"
      sx={{ cursor: 'pointer' }}
      onClick={props.onClick}
    >
      {props.children}
    </Box>
  )
}

export default StyledTab;